import { observer } from '@rehaje/reactive-react'
import { createElement } from 'react'

import { ValuableModel } from '../models'

import type { SchemaModel } from '../models'
import type { FC } from 'react'

export interface WidgetViewProps {
  children?: any
  model: SchemaModel
  target: any
}

export const WidgetView: FC<WidgetViewProps> = observer(
  ({ children, model, target }) => {
    if (typeof target?.render === 'function')
      return target.render(children) ?? children
    if (typeof target?.type === 'function') {
      const valuable =
        model instanceof ValuableModel ? model : model.valuableParent
      return createElement(target?.type, valuable?.getComponentProps(target))
    }
    if (target?.$$typeof) return target
    if (target?.type?.$$typeof) {
      const valuable =
        model instanceof ValuableModel ? model : model.valuableParent
      return createElement(target?.type, valuable?.getComponentProps(target))
    }
    return children
  }
)
